export type TagKey = "神转折" | "结局意外" | "剧情神展开" | "结尾反转" | "意外收场";

export interface TwistStory {
  id: number;
  title: string;
  hook: string;
  twist: string;
  tag: TagKey;
  category: string;
  author: string;
  date: string;
  views: number;
  likes: number;
  img?: string;
}

export const tagMap: Record<TagKey, string> = {
  神转折: "text-accent-700 bg-accent-100 border-accent-200",
  结局意外: "text-primary-700 bg-primary-100 border-primary-200",
  剧情神展开: "text-secondary-800 bg-secondary-100 border-secondary-200",
  结尾反转: "text-accent-700 bg-accent-100 border-accent-200",
  意外收场: "text-primary-700 bg-primary-100 border-primary-200",
};

export const categories = [
  { name: "职场反转", icon: "ri-briefcase-2-line", count: 326 },
  { name: "感情瓜田", icon: "ri-heart-2-line", count: 458 },
  { name: "邻里奇闻", icon: "ri-home-5-line", count: 217 },
  { name: "家庭伦理", icon: "ri-group-line", count: 289 },
  { name: "悬疑开局", icon: "ri-user-star-line", count: 173 },
  { name: "财富逆转", icon: "ri-copper-coin-line", count: 142 },
  { name: "校园热搜", icon: "ri-school-line", count: 231 },
  { name: "网友神评", icon: "ri-chat-smile-3-line", count: 384 },
];

export const navLinks = [
  { label: "神转折头条", href: "#hot" },
  { label: "分类瓜田", href: "#categories" },
  { label: "反转现场", href: "#library" },
  { label: "结局盘点", href: "#ranking" },
  { label: "网友锐评", href: "#voices" },
  { label: "常见问题", href: "#faq" },
];

export const featuredStories: TwistStory[] = [
  {
    id: 1,
    title: "「加班到凌晨的功臣」被全公司表扬，结果表扬完就被辞退了",
    hook: "连续三个月主动加班、项目救火、全组夸他是劳模。庆功会上领导举杯说“你辛苦了”，他还感动得眼眶发红——直到第二天 HR 约他聊“公司组织调整”。",
    twist: "那场全员到场的表扬会，本质是一场体面的离场仪式。老板私下说：不给他糖，怎么舍得让他把项目收尾完？原来他救下的项目，早被内部定好了要转给别人带。",
    tag: "神转折",
    category: "职场反转",
    author: "摸鱼观察员",
    date: "2026-09-04",
    views: 128400,
    likes: 9213,
    img: "https://readdy.ai/api/search-image?query=Warm%20flat%20editorial%20illustration%20of%20an%20office%20desk%20with%20stacks%20of%20paper%20and%20files%2C%20a%20bright%20lightbulb%20moment%20glowing%20above%2C%20one%20employee%20silhouette%20leaving%20through%20a%20door%20in%20the%20background%2C%20warm%20coral%2C%20amber%20and%20cream%20color%20palette%2C%20bold%20minimal%20magazine%20graphic%20style%2C%20no%20text&width=1200&height=900&seq=chigua-feat-big-01&orientation=landscape",
  },
  {
    id: 2,
    title: "闺蜜说“这男的我不跟你抢”，两年后婚礼上她成了新娘",
    hook: "她跟闺蜜聊起心动的男生，闺蜜拍胸脯保证“姐妹的男人我绝不动”。两年里三人一起吃饭、出游，她以为关系早已说开。直到婚礼邀请函寄到家——新娘的名字，是闺蜜。",
    twist: "那两年每次“三人聚餐”，男方跟闺蜜其实都在桌下传消息。闺蜜那句保证说得真诚，转头就把“感动”变成了“近水楼台”。婚礼上她没去，退回了份子钱。",
    tag: "结局意外",
    category: "感情瓜田",
    author: "红毯看客",
    date: "2026-09-06",
    views: 156900,
    likes: 11027,
    img: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20two%20chat%20phone%20screens%20side%20by%20side%20with%20a%20heart%20icon%20and%20a%20broken%20heart%20icon%20colliding%20in%20the%20middle%2C%20cream%20background%20with%20coral%20orange%20accents%2C%20playful%20minimal%20graphic%20style%2C%20soft%20highlights%2C%20no%20text%2C%20no%20people&width=720&height=540&seq=chigua-feat-1-01&orientation=landscape",
  },
  {
    id: 3,
    title: "相亲对象点最贵菜还打包，大家笑他抠，最后他把账结了还送了套房",
    hook: "一场相亲饭局，男方全程只点招牌硬菜，吃完让服务员全打包。桌上几位长辈交换眼神，都在笑话他“小家子气”。他低头看手机，一句话没说。",
    twist: "那些“硬菜”是他爸住院后唯一肯多吃几口的家乡味，打包是给病床上的老人。结账时他默默买了整桌单，还托人打听到女孩家缺个学区房，直接送了一套首付。",
    tag: "意外收场",
    category: "感情瓜田",
    author: "饭局目击者",
    date: "2026-09-02",
    views: 98300,
    likes: 7641,
    img: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20dining%20table%20with%20steaming%20dishes%20and%20takeaway%20boxes%2C%20a%20small%20house%20silhouette%20and%20key%20appearing%20above%2C%20warm%20sand%2C%20amber%20and%20cream%20tones%2C%20bold%20minimal%20magazine%20art%2C%20cozy%20atmosphere%2C%20no%20text%2C%20no%20people&width=720&height=540&seq=chigua-feat-2-01&orientation=landscape",
  },
  {
    id: 4,
    title: "小区遛狗阿姨天天夸狗乖，直到深夜她牵着狗堵住了楼下小偷",
    hook: "楼下阿姨养了只胖柴犬，见谁都咧着嘴笑，是全小区公认的乖狗。可连续三晚，阿姨都牵着它站在楼道转角，像是在等什么人。",
    twist: "那狗早训成了看门犬。小偷摸进一楼偷电瓶，刚弯腰就被狗扑倒，阿姨淡定掏出手机录像报警。原来“天天遛狗”只是她的巡逻伪装，狗早就闻熟了楼道里不正常的脚步。",
    tag: "剧情神展开",
    category: "邻里奇闻",
    author: "深夜蹲点党",
    date: "2026-08-29",
    views: 87500,
    likes: 6802,
    img: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20cute%20fluffy%20dog%20silhouette%20and%20an%20elderly%20person%20holding%20a%20leash%20standing%20at%20a%20dim%20residential%20corridor%20at%20night%2C%20moonlight%20cast%20shadow%2C%20warm%20coral%20and%20cream%20palette%2C%20playful%20mystery%20magazine%20style%2C%20no%20text&width=720&height=540&seq=chigua-feat-3-01&orientation=landscape",
  },
];

export const hotSmallStories: TwistStory[] = [
  {
    id: 5,
    title: "考编上岸第一名的学霸，面试官看到她姓名后当场改名了",
    hook: "她笔试第一，面试当天自我介绍报完名字，主考官明显愣了一下，随后在纸上圈圈画画。她以为是自己紧张说错了什么。",
    twist: "主考官是二十年前她读小学时，因为一句“别欺负她”而帮过她的那个热心邻居。如今她被招进他所在单位，他只在表格里郑重写下：欢迎回家，这回换你照顾大家。",
    tag: "结尾反转",
    category: "职场反转",
    author: "上岸锦鲤",
    date: "2026-08-31",
    views: 76300,
    likes: 5489,
  },
  {
    id: 6,
    title: "老板天天画饼说“年底分红”，离职那天他给了一张房卡",
    hook: "干了五年，老板画的饼从“期权”画到“出国游”，她终于提了离职。老板没挽留，只递过来一张卡，她以为是年终奖的糊弄。",
    twist: "那是她家隔壁那套一直没卖出的小户型房卡。老板早就用她五年绩效攒下的资金买了套投资房，本打算年底给个惊喜，结果她先提了走人。卡上贴着纸条：房留你住，人想走就走吧。",
    tag: "结局意外",
    category: "职场反转",
    author: "搬砖侠",
    date: "2026-08-27",
    views: 67100,
    likes: 4932,
  },
];

export const libraryStories: TwistStory[] = [
  {
    id: 7,
    title: "同事总抢我功劳，我忍了三年，离职那天老板请我吃饭",
    hook: "创意被抢、汇报被顶名、绩效被冒领，三年里我没吭一声。提交离职申请那天，老板却主动订了楼下的包间。",
    twist: "包间里坐着那位“抢功劳”的同事。老板拿出两沓材料：一沓是我的原始提案草稿，一沓是他多年冒领后绩效虚高、正被查的账单。原来老板一直在等我开口，好借机把蛀虫送走。",
    tag: "结尾反转",
    category: "职场反转",
    author: "老实人不老实",
    date: "2026-09-05",
    views: 112300,
    likes: 9861,
  },
  {
    id: 8,
    title: "朋友圈晒“跳槽成功”，其实我连简历都没投",
    hook: "更新了一版“新东家欢迎我”的动态，配了张写字楼夜景，收获一片羡慕。真相是，我根本没投任何简历。",
    twist: "那条动态是发给前老板看的。他压我薪资压了两年，我反向营销自己“很抢手”，果然他连夜涨薪挽留。写字楼夜景是我实习时拍的，人没走，价却涨了四成。",
    tag: "神转折",
    category: "职场反转",
    author: "反向内卷王",
    date: "2026-09-03",
    views: 90200,
    likes: 7205,
  },
  {
    id: 9,
    title: "相亲男说“我家条件一般”，结果车钥匙掉出三把",
    hook: "他说家里就是普通工薪，怕我介意。结账时钱包滑落，哗啦掉出一串钥匙——三把不同的。我当场想找借口溜。",
    twist: "那三把钥匙分别是他爸妈家、出租屋和自己住处。真正扎心的是另一张卡：是他存了六年给妈妈换人工关节的钱，备注写着“姐姐的嫁妆我先帮着攒”。条件一般，心不一般。",
    tag: "意外收场",
    category: "感情瓜田",
    author: "相亲研究所",
    date: "2026-08-30",
    views: 84500,
    likes: 6603,
  },
  {
    id: 10,
    title: "楼下天天凌晨剁馅的早餐店，原来是在给楼上独居老人送饭",
    hook: "每天凌晨四点，楼下“剁馅”声准时吵醒我，投诉过两次也没用。我气冲冲下去理论，结果被眼前一幕看愣了。",
    twist: "剁的不是包子馅，是在把瘦肉打成糊给楼上腿脚不便的独居老人做流食。那老人是她失散多年的小学老师，凌晨剁馅是为了赶上老人服药后那一小时的进食窗口。",
    tag: "剧情神展开",
    category: "邻里奇闻",
    author: "被吵醒的邻居",
    date: "2026-08-28",
    views: 79900,
    likes: 6022,
  },
  {
    id: 11,
    title: "婆婆催我生二胎，催了一年，最后自己偷偷去领养了猫",
    hook: "催二胎催到饭桌上掉眼泪，我顶着压力没松口。直到某天我加班回家，发现她正对着手机抹眼泪。",
    twist: "她年轻时为了照顾公公错过了要二胎的年纪，如今把遗憾全补到了一只流浪橘猫身上。她说：孩子是我的责任，养它是我自己的热闹，你俩好好过日子就行。",
    tag: "意外收场",
    category: "家庭伦理",
    author: "儿媳视角",
    date: "2026-08-25",
    views: 74100,
    likes: 5330,
  },
  {
    id: 12,
    title: "考研二战上岸名校，通知书里夹了张前男友的便签",
    hook: "第二年备考那年，我几乎跟所有朋友断了联系，前男友也删了我。收到录取通知书的快递，拆开却发现里面多了一张纸条。",
    twist: "便签是他托寄件人放进去的：那半年他天天在图书馆角落陪我背书，只是从不靠近。他考去了另一座城市读研，留言“你值得被更好的自己追”。重逢是剧本，错过是常态。",
    tag: "结尾反转",
    category: "校园热搜",
    author: "图书馆常客",
    date: "2026-08-22",
    views: 88600,
    likes: 7051,
  },
  {
    id: 13,
    title: "公司茶水间最爱八卦的大姐，竟然是隐藏的董事会秘书",
    hook: "茶水间八卦一姐，谁家事她都接得上话，大家把她当情报站。直到季度会上，她端坐在董事会旁，微笑着一一回应了那些“内部消息”。",
    twist: "她不是爱八卦，是故意在茶水间放风试探忠诚度。那些被她“无意间”说漏的消息，全是用来揪内鬼的饵。当天下午，就有两位泄密的中层被约谈。",
    tag: "剧情神展开",
    category: "职场反转",
    author: "茶水间卧底",
    date: "2026-08-20",
    views: 123600,
    likes: 10420,
  },
  {
    id: 14,
    title: "闺蜜炒股亏光嫁妆，结果她妈笑着说“你爸早给你买了房”",
    hook: "她把攒了八年的嫁妆全梭哈进一支“内幕股”，三天亏到只剩零头，哭着打电话给家里坦白。电话那头安静了很久。",
    twist: "她妈笑出声：“就猜你会栽。”原来那套房她爸六年前就写了她名，钱早备好了，炒股亏的是她从基金里借的——她妈早收到过基金公司的风控提示，一直等着她承认。",
    tag: "结局意外",
    category: "财富逆转",
    author: "韭菜日记",
    date: "2026-08-18",
    views: 69500,
    likes: 5120,
  },
  {
    id: 15,
    title: "楼下保安总对我敬礼，直到我搬走那天他才说出真话",
    hook: "住这三年，楼下保安每次见我不管多远都敬礼，搞得我很不自在，以为是服务要求。搬家那天我特意去道谢。",
    twist: "他敬的不是礼，是报恩。五年前他在夜市摆摊被人讹，是我爸——一个当时恰好路过的陌生大叔——替他还了那笔冤枉钱。我爸没跟家里提，他却记了整整五年。",
    tag: "意外收场",
    category: "邻里奇闻",
    author: "搬家的回忆",
    date: "2026-08-15",
    views: 64400,
    likes: 4866,
  },
  {
    id: 16,
    title: "小学同学群突然拉我，是为了给我补一句迟到的道歉",
    hook: "毕业十二年的小学同学突然把我拉进群，我心一沉，以为是要随份子。结果全员沉默半天，班长率先开腔。",
    twist: "当年我转学前，有人传我偷东西，导致我被孤立到不敢上学。班长用十二年攒齐证据，今天在群里替我澄清：偷钱的真凶是他同桌，当年就查出来了，只是没人敢说。全班在群里排着队跟我道歉。",
    tag: "结尾反转",
    category: "校园热搜",
    author: "迟到的正义",
    date: "2026-08-12",
    views: 99100,
    likes: 8177,
  },
];

export const rankingStories: TwistStory[] = [
  {
    id: 17,
    title: "「最抠门」的合租室友，攒钱给全楼老人交了取暖费",
    hook: "合租三年他抠到出奇，冬天空调都舍不得开。我们都以为他穷，直到那年大雪，他突然敲开整栋楼的门。",
    twist: "他把攒的工资全用来给楼里十几户独居老人补交了取暖费。他自己那间，其实是整栋楼里唯一没通暖气的老屋。",
    tag: "意外收场",
    category: "邻里奇闻",
    author: "被冻醒的室友",
    date: "2026-08-10",
    views: 175300,
    likes: 18230,
  },
  {
    id: 18,
    title: "天天点外卖被嘲“不会做饭”，其实他是小区食堂主厨",
    hook: "外卖包装袋堆满垃圾桶，同事们调侃他“外卖博主”。直到公司团建订到一家网红餐厅，后厨掀帘走出来的竟是同一个人。",
    twist: "他白天是这家餐厅主厨，晚上住公司隔壁。点外卖是为了「试吃竞品」改进自家菜品，垃圾桶里全是竞争对手的样品袋。",
    tag: "剧情神展开",
    category: "职场反转",
    author: "外卖侦察兵",
    date: "2026-08-08",
    views: 132800,
    likes: 12940,
  },
  {
    id: 19,
    title: "婚礼上新郎把捧花丢给伴娘，其实是想借机把戒指还她",
    hook: "交换完戒指，新郎突然把捧花转身递给主伴娘，全场掌声以为是“接好运”。新娘脸上的笑却僵住了。",
    twist: "伴娘是新娘的妹妹，五年前替姐姐家扛下债务辍学打工。那枚“捧花里藏着的旧戒指”，是妹妹当年偷偷卖掉想换学费的那枚。婚礼成了她补上的毕业礼。",
    tag: "结局意外",
    category: "家庭伦理",
    author: "婚礼摄影师",
    date: "2026-08-05",
    views: 160500,
    likes: 15510,
  },
];

export const voices = [
  {
    nickname: "爱吃瓜的椰子",
    text: "每个标题都能精准吊起我的胃口，点开前总以为猜到结局，结果次次被打脸。这个站真不让人失望，连续追更好几天了。",
    tag: "反转爱好者",
  },
  {
    nickname: "睡前故事雷达",
    text: "把「悬念」和「反转」拆成两段的设计太妙了，先憋着不剧透，想通了自己再点开揭晓，仪式感拉满，评论区也都好欢乐。",
    tag: "每晚必刷",
  },
  {
    nickname: "住在瓜田里",
    text: "分类很细，职场、邻里、校园都有，终于不用在别人主页一条条翻了。攒起来一口气看完神转折真的舒服。",
    tag: "深度潜水",
  },
  {
    nickname: "理性吃瓜er",
    text: "内容标注得清清爽爽，反转是反转、吐槽是吐槽，不会被标题党套路，看得出整理的人很用心。",
    tag: "挑剔用户",
  },
];

export const faqItems = [
  {
    q: "吃瓜反差里的故事是真的吗？",
    a: "这里的内容以「投稿整理 + 二次演绎」为主，真实来源会标注投稿人昵称，但为保护隐私和避免误导，多数故事都经过了模糊化处理。看反转图一乐可以，别把细节对号入座到现实里的真人真事哦。",
  },
  {
    q: "为什么这些故事的结局总是意想不到？",
    a: "因为我们按「反差」来挑内容——只看前半段平平无奇、结尾却神展开或反转的那类瓜。刻意收起结尾、先展示悬念，就是为了让你自己先猜一次，再被结尾打脸，体会那种反转的爽感。",
  },
  {
    q: "我身边也有这种神转折，怎么投稿？",
    a: "非常欢迎！你可以通过页面底部或联系我们区域的投稿邮箱发送你的故事，写明时间、人物关系和你经历的那次反转即可。录用后我们会匿名整理并标注你的昵称。投稿即代表你同意本站匿名转载整理。",
  },
  {
    q: "内容多久更新一次？",
    a: "我们会定期整理「神转折头条」与「反转现场」栏目，也会根据网友呼声调整分类顺序。遇到集中爆发的吃瓜事件时，会临时加更对应专题，尽量让大家不错过新鲜热乎的反转瓜。",
  },
  {
    q: "如果故事涉及现实熟人，会泄露隐私吗？",
    a: "不会。所有涉及真人的内容在发布前都会做匿名化处理，替换姓名、地点与可识别细节，并通过你的投稿授权确认。若你发现自己被误代入某篇内容，可随时联系我们处理，核实后会第一时间下架。",
  },
  {
    q: "这里可以转载/搬运内容吗？",
    a: "本站原创整理内容欢迎在注明出处与作者昵称的前提下合理转载；如属网友来稿，转载需另获原作者同意。商用或大量搬运请先通过联系我们邮箱沟通，谢谢理解。",
  },
];